import React, { ReactNode } from 'react';
import { Translate } from 'react-redux-i18n';
import ConnectionInformationForm from './ConnectionInformationForm';

type Props = {
  onClose: () => void
  setDirty?: (dirty: boolean, callback?: () => void) => void
  setModalI18n?: (title: string, subtitle: string) => void
  pseudo: string,
  fetchPseudo: () => void,
};

type State = {
};

class ConnectionInformation extends React.Component<Props, State> {
  state: State = {};

  render(): ReactNode {
    return (
      <div>
        <div className="centered-form">
          <div className="drawer-title">
            <h3>
              <Translate value="CONNECTION_INFORMATION.CONNECTION_INFORMATION" />
            </h3>
            <div className="subtitle">
              <Translate value="CONNECTION_INFORMATION.CONFIDENTIAL" />
            </div>
          </div>
          <ConnectionInformationForm
            onClose={this.props.onClose}
            setDirty={this.props.setDirty}
            setModalI18n={this.props.setModalI18n}
            pseudo={this.props.pseudo}
            fetchPseudo={this.props.fetchPseudo}
          />
        </div>
      </div>
    );
  }
}

export default ConnectionInformation;
